"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
// @inheritedComponent Radio

var styles = exports.styles = function styles(theme) {
  return {
    checked: {
      color: theme.palette.neutral.main
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    root: {
      height: 40,
      width: 40
    }
  };
};
var HiRadio = function HiRadio(_ref) {
  var checked = _ref.checked,
    classes = _ref.classes,
    className = _ref.className,
    color = _ref.color,
    disabled = _ref.disabled,
    label = _ref.label,
    onChange = _ref.onChange,
    value = _ref.value;
  var hcolor = ['success', 'error', 'warning', 'neutral', 'inherit'].includes(color) ? 'default' : color;
  return /*#__PURE__*/_react.default.createElement(_Radio.default, {
    className: className,
    classes: {
      root: classes.root,
      checked: classes.checked,
      disabled: classes.disabled
    },
    checked: checked,
    color: hcolor,
    label: label,
    onChange: onChange,
    disabled: disabled,
    value: value
  });
};
HiRadio.defaultProps = {};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiRadio'
})(HiRadio);